import createItemOperation from 'owa-service/lib/operation/createItemOperation';
import createItemRequest from 'owa-service/lib/factory/createItemRequest';
import CreateItemResponse from 'owa-service/lib/contract/CreateItemResponse';
import Message from 'owa-service/lib/contract/Message';
import { getJsonRequestHeader } from 'owa-service/lib/ServiceRequestUtils';

export default function sendMessage(
    message: Message,
    timeFormat: string
): Promise<CreateItemResponse> {
    let request = createItemRequest({
        ClientSupportsIrm: false,
        ComposeOperation: 'newMail',
        MessageDisposition: 'SendAndSaveCopy',
        OutboundCharset: 'AutoDetect',
        PromoteEmojiContentToInlineAttachmentsCount: 0,
        Items: [message],
        UnpromotedInlineImageCount: 0,
        TimeFormat: timeFormat,
    });

    return createItemOperation({
        Header: getJsonRequestHeader(),
        Body: request,
    }).then(response => {
        return response.Body;
    });
}
